import React from 'react';
import { PageIndices } from '../../common/i-doc/i-doc.registry.ts';
import { DashboardLayout } from '@components/DashboardLayout.tsx';
import { SchedulerManager } from '@components/development/SchedulerManager.tsx';
import { Box } from '@mui/material';

export const AdminSchedulerPage: React.FC = () => {
  return (
    <DashboardLayout>
      <Box data-i-doc={PageIndices.ADMIN_SCHEDULER}>
        <SchedulerManager />
      </Box>
    </DashboardLayout>
  );
};
